import { RouterState } from "mobx-state-router";

const checkForUserLogin = (fromState, toState, routerStore) => {
  const { authStore } = routerStore.rootStore;
  if (authStore.isLogin()) {
    return Promise.resolve();
  } else {
    authStore.setLoginRedirect(toState);
    return Promise.reject(new RouterState("loginPanel"));
  }
};

// Routes are matched from top to bottom. Make sure they are sequenced
// in the order of priority. It is generally best to sort them by pattern,
// prioritizing specific patterns over generic patterns (patterns with
// one or more parameters). For example:
//     /items
//     /items/:id
export const routes = [
  {
    name: "homePanel",
    pattern: "/",
    onEnter: (fromState, toState, routerStore) => {
      const { codeMapStore } = routerStore.rootStore;
      codeMapStore.loadCodeMaps({});
      return Promise.resolve();
    },
    beforeEnter: checkForUserLogin
  },
  {
    name: "loginPanel",
    pattern: "/loginPanel"
  },
  {
    name: "changePasswordPanel",
    pattern: "/changePasswordPanel",
    beforeEnter: checkForUserLogin
  },
  {
    name: "codeMapPanel",
    pattern: "/codeMapPanel",
    onEnter: (fromState, toState, routerStore) => {
      const { codeMapStore } = routerStore.rootStore;
      codeMapStore.loadCodeMaps({});
      return Promise.resolve();
    },
    beforeEnter: checkForUserLogin
  },
  { name: "notFound", pattern: "/not-found" }
];
